import React from "react";
import Auslegungen from "./Auslegungen";
import Planungen from "./Planungen";
import Foerdermassnahmen from "./Foerdermassnahmen";

export default function AuslegungenPlanungFoerdermassnahmen(props) {
    const onChange = (name, data) => {
        props.onChange(name, data);
    };

    return (
        <div className="tabsheet-content-margin">
            <Auslegungen
                formFactory={props.formFactory}
                data={props.data.auslegungUndBelastungsDaten}
                errors={props.errors}
                onChange={onChange}
                anlegen={props.anlegen}
                modus={props.modus}
                anlagentyp={props.anlagentyp}
            />
            <div style={{ paddingTop: "4px" }} />
            <Planungen
                formFactory={props.formFactory}
                anlage={props.data}
                data={props.data.planungen}
                errors={props.errors}
                onChange={onChange}
                anlegen={props.anlegen}
                modus={props.modus}
                betriebsId={props.betriebId}
                anlagentyp={props.anlagentyp}
            />
            <div style={{ paddingTop: "4px" }} />
            <Foerdermassnahmen
                formFactory={props.formFactory}
                data={props.data.foerderungen}
                errors={props.errors}
                onChange={onChange}
                anlegen={props.anlegen}
                modus={props.modus}
                anlagentyp={props.anlagentyp}
            />
            <div style={{ paddingTop: "4px" }} />
        </div>
    );
}
